import { AmbientGlow } from "./_shared";

// Ported from Claude Design handoff (sections-rest: Testimonials).
// Oversized decorative quote, centered blockquote, 4-metric grid.

const METRICS = [
  { v: "11+", l: "Monitores Ativos" },
  { v: "24/7", l: "Monitoramento" },
  { v: "PT-BR", l: "IA em Português" },
  { v: "<48h", l: "Primeiro Relatório" },
];

export function Testimonials() {
  return (
    <section
      className="cy-section"
      style={{
        position: "relative",
        padding: "140px 40px",
        background: "var(--cy-bg)",
        borderTop: "1px solid var(--cy-ink-10)",
        overflow: "hidden",
      }}
    >
      <AmbientGlow variant="tr-bl" />
      <div
        style={{
          position: "relative",
          zIndex: 1,
          maxWidth: 1000,
          margin: "0 auto",
          textAlign: "center",
        }}
      >
        <div
          className="cy-quote-deco"
          style={{
            fontFamily: "var(--cy-fs-sans)",
            fontSize: 120,
            lineHeight: 0.8,
            color: "var(--cy-accent)",
            opacity: 0.4,
            marginBottom: -40,
            userSelect: "none",
          }}
          aria-hidden
        >
          “
        </div>
        <blockquote
          style={{
            margin: 0,
            fontFamily: "var(--cy-fs-sans)",
            fontSize: "clamp(22px, 2.7vw, 32px)",
            lineHeight: 1.35,
            fontWeight: 400,
            color: "var(--cy-ink-100)",
            letterSpacing: "-0.015em",
            textWrap: "balance",
          }}
        >
          A usabilidade e o foco em relatórios compreensíveis resolvidos pela
          IA mudam o jogo para as pequenas empresas que não têm TI interno.
        </blockquote>

        <div
          style={{
            marginTop: 32,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 16,
          }}
        >
          <div
            style={{
              width: 44,
              height: 44,
              borderRadius: "50%",
              background:
                "linear-gradient(135deg, var(--cy-accent), var(--cy-bg-elev-2))",
              border: "1px solid var(--cy-ink-10)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#0A1500",
              fontWeight: 600,
              fontSize: 14,
            }}
          >
            RS
          </div>
          <div style={{ textAlign: "left" }}>
            <div
              style={{
                fontSize: 14,
                fontWeight: 500,
                color: "var(--cy-ink-100)",
              }}
            >
              Professor of Cybersecurity
            </div>
            <div
              className="cy-mono"
              style={{
                fontSize: 11,
                color: "var(--cy-ink-60)",
                letterSpacing: "0.08em",
              }}
            >
              Brazilian technical university
            </div>
          </div>
        </div>

        <div
          className="cy-grid-4"
          style={{
            marginTop: 72,
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: 1,
            background: "var(--cy-ink-10)",
            border: "1px solid var(--cy-ink-10)",
          }}
        >
          {METRICS.map((m) => (
            <div
              key={m.l}
              style={{
                background: "var(--cy-bg)",
                padding: "32px 16px",
              }}
            >
              <div
                style={{
                  fontSize: 42,
                  fontWeight: 500,
                  color: "var(--cy-accent)",
                  letterSpacing: "-0.03em",
                  lineHeight: 1,
                }}
              >
                {m.v}
              </div>
              <div className="cy-tape" style={{ marginTop: 10 }}>
                {m.l}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
